/**
 * Обернуть строку слева и справа
 *
 * @param wrapperLeft - префикс, который будет добавлен слева от строки
 * @param stringToWrap - строка, которую надо обернуть
 * @param wrapperRight - суффикс будет добавлен справа от строки. Если не передан, то добавится wrapperLeft
 *
 * @example stringWrap("{", "value", "}") === "{value}"
 * @example stringWrap("{", "value") === "{value{"
 */
export const stringWrap = (
  wrapperLeft: string,
  stringToWrap: string,
  wrapperRight?: string
): string => `${wrapperLeft}${stringToWrap}${wrapperRight || wrapperLeft}`;
